/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetMarketMakerOptions, GetMarketMakerResponses } from '../types/GetMarketMaker'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Admin only. All percentages are fractions in [0,1].
 * @summary Get a market maker
 * {@link /v1/market-makers/:market_maker_id}
 */
export function getMarketMaker<ThrowOnError extends boolean = true>(
  options: Options<GetMarketMakerOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetMarketMakerResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/market-makers/{market_maker_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetMarketMakerResponses, ThrowOnError>>,
  )
}
